'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _class = function () {
  function _class() {
    _classCallCheck(this, _class);
  }

  _createClass(_class, [{
    key: 'init',
    value: function init() {
      this.$el = $('[data-role="magnific"]');

      /**
       * Change the defaul magnificPopup functionality
       * by editing the objectin Config class or attach
       * the popup with a custom config to another
       * element below here.
       */

      this.$el.each(function (index, el) {
        $(el).magnificPopup(App.config.magnificPopup);
      });
    }
  }]);

  return _class;
}();

export default _class;


//////////////////
// WEBPACK FOOTER
// ./resources/templates/semperit/assets/js/modules/magnific-popup/index.js
// module id = qBnN
// module chunks = 4